/* eslint-disable class-methods-use-this */
import { api } from 'services';
import { UserService } from 'modules/user';
import { NOTIFICATION_CHANNEL } from './notification.model';
import Transformer from './transformers';

class NotificationService {
    static bulkCreate(data) {
        const postData = Transformer.out(data);
        return api.post('/customNotifications', postData);
    }

    static bulkList(...args) {
        return api.list('/customNotifications', ...args)
            .then(Transformer.list);
    }

    // generic user list
    static list = (...args) => api.list('/notifications', ...args)
            .then(Transformer.list);

    static update = (id, data) => api.put(`/notifications/${id}`, data);

    // get current user history 
    static getAlersHistory() {
        return this.list({
            page: 1,
            take: 1000,
            filters: {
                archivedAt: { pattern: 'NULL' },
                channel: NOTIFICATION_CHANNEL.app,
                userId: UserService.id,
            }
        });
    }

    static getAlertsUnread() {
        return this.list({
            page: 1, 
            take: 10, 
            filters: {
                readAt: { pattern: 'NULL' },
                archivedAt: { pattern: 'NULL' },
                channel: NOTIFICATION_CHANNEL.app,
                userId: UserService.id,
            }
        });
    }

    static getAlertsArchived() {
        return this.list({
            page: 1, 
            take: 1000, 
            filters: {
                archivedAt: { pattern: 'NULL', not: true },
                channel: NOTIFICATION_CHANNEL.app,
                userId: UserService.id,
            }
        });
    }

    static markRead(id) {
        return api.post(`/notifications/${id}`);
    }

    static delete(id) {
        return api.delete(`/notifications/archived/${id}`);
    }

    static download(...args) {
        return api.download(...args);
    }

    static listByPatient({ patientId, page, take, filters, sort }) {
        return api.list(`/patients/${patientId}/notifications`, { page, take, filters, sort })
            .then(Transformer.list);
    }
}

export { NotificationService }; 
